module.exports = __webpack_public_path__ + "img/logo-ragnvald.be9d01a0.png";